/**
 * @internal
 */
export const packageVersion = '24.7.2';
//# sourceMappingURL=version.js.map